import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectChatAssignmentCriteriaSchema = createSelector(
  getSystem,
  ({ chatAssignmentCriteriaSchema }) => chatAssignmentCriteriaSchema,
);
